<ng-content></ng-content>
<span class="one">.</span>
<span class="two">.</span>
<span class="three">.</span>
